import { useEffect } from "react";
import { useGetActiveSubscriptions } from "pages/pricing/hooks/useGetActiveSubscriptions";

export const useSubscriptionPolling = (enabled = true, intervalMs = 5000) => {
  const { subscriptions, refetch } = useGetActiveSubscriptions();

  useEffect(() => {
    if (!enabled) return;
    const interval = setInterval(() => refetch(), intervalMs);
    return () => clearInterval(interval);
  }, [enabled, refetch, intervalMs]);

  return { subscriptions, refetch };
};
